import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { capturarEnlace } from '../lib/enlace';

/**
 * `vondi.mx/r/CODIGO` — la puerta de los enlaces de referido.
 *
 * Resuelve el código, cuenta la visita y manda a la persona a donde le toca:
 * al flujo del beneficio de bienvenida si el enlace lo da, o a la portada si
 * no. Un código que no existe también lleva a la portada, sin error: quien
 * escaneó un QR viejo tiene que encontrarse con la tienda, no con un mensaje.
 */
export default function EnlaceEntrada() {
  const { codigo } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let vigente = true;
    capturarEnlace(codigo).then((enlace) => {
      if (!vigente) return;
      navigate(enlace?.da_beneficio ? '/beneficios' : '/', { replace: true });
    });
    return () => { vigente = false; };
  }, [codigo, navigate]);

  return <div style={{ minHeight: '100vh', background: '#fff' }} />;
}
